import { fetchQuery } from 'react-relay';
import environment from 'shared/relay/environment';
import query from './private-route.query';

const getMorePackageInfo = packageId => {
  return new Promise((resolve, reject) =>
    fetchQuery(environment, query, {
      packageId
    })
      .then(queryProps => resolve(queryProps))
      .catch(error => reject(error))
  );
};

function privateRouteService() {
  return {
    getMorePackageInfo
  };
}

export default privateRouteService();
